import idx from "idx";
import { connect } from "react-redux";
import { IState } from "../../../App/reducer";
import * as selectors from "../../../selectors/selectors";
import { ISideMenuStateProps, SideMenuComponent } from "./SideMenu.component";

const mapStateToProps = (state: IState): ISideMenuStateProps => ({
  accountId: idx(state, ({ App }) => App._.user.accountId) || "",
  classAmount: state.App._.objectsAmount.classAmount,
  courseAmount: state.App._.objectsAmount.courseAmount,
  exportedScormPackagesAmount: state.App._.objectsAmount.exportedScormPackagesAmount,
  groupsAmount: state.App._.objectsAmount.groupsAmount,
  isOrgAdmin: selectors.isOrgAdmin(state),
  usersAmount: state.App._.objectsAmount.usersAmount,
});

export const SideMenu = connect(mapStateToProps)(SideMenuComponent);
